import React from 'react';
import './App.css';
import Layout from './components/Layout/Layout';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import  Home  from './screens/Home/Home';
import  Employer  from './screens/Employer/Employer';
import  Service  from './screens/Service/Service';
import Openings from './screens/Openings/Openings';
import  {useTranslation}  from 'react-i18next';
import  AboutUs  from './screens/AboutUs/AboutUs';
import  ContactUs  from './screens/ContactUs/ContactUs';
import  HrSolution  from './screens/HrSolution/HrSolution';
import  Application  from './screens/Application/Application';
import JobCard from './screens/Openings/JobCart';
import Dropresume from './screens/Openings/Dropresume';
import UploadPDF from './screens/Application/up';
// import InquiryForm from './screens/InquiryForm/InquiryForm';

function App() {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    // Set text direction based on the language (RTL for Arabic)
    document.body.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);


  return (
    <Router>

      <Layout>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/employer" element={<Employer />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path='/service' element={<Service />}></Route>
          <Route path='/applicant' element={<Application></Application>}></Route>
          <Route path='/contact' element={<ContactUs/>}></Route>
          <Route path='/hr-solution' element={<HrSolution></HrSolution>}></Route>
          <Route path='/opening' element={<Openings></Openings>}></Route>
          <Route path='/opening/:jobId' element={<JobCard/>}></Route>
          {/* <Route path=" /opening/job" element={<JobCard />} /> */}
         
          <Route path='/opening/:jobId/apply' element={<Dropresume/>}></Route>
<Route path='/UploadPDF' element={<UploadPDF/>}></Route>


        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
